<template>
  <a-modal
    v-model:visible="localVisible"
    :title="$t('label.create.ssh.key.pair')"
    :footer="null"
    @cancel="closeModal"
    @afterOpen="resetForm">
    <CreateSSHKeyPair
      @close-action="closeModal"
      @refresh-data="refreshData"
    />
  </a-modal>
</template>

<script>
import CreateSSHKeyPair from '@/views/compute/CreateSSHKeyPair.vue'

export default {
  name: 'CreateKeyPairModal',
  components: {
    CreateSSHKeyPair
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['update:visible', 'refresh-data'],
  data () {
    return {
      localVisible: this.visible
    }
  },
  watch: {
    visible (newVal) {
      this.localVisible = newVal
    }
  },
  methods: {
    closeModal () {
      this.localVisible = false
      this.$emit('update:visible', false)
    },
    refreshData () {
      this.$emit('refresh-data')
    }
  }
}
</script>
